import { FC, memo, useCallback } from 'react';
import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';
import { PageErrorMessage } from '@ebsco-ui/ebsco-ui';

import { Image } from '@app/components';
import { Route } from '@app/constants';

import NotFoundImage from './NotFoundImage.svg';

import css from './NotFoundPage.module.scss';

export const NotFoundPage: FC = memo(() => {
  const navigate = useNavigate();
  const { $t } = useIntl();
  const navigateToSearchPage = useCallback(() => {
    navigate(Route.search);
  }, [navigate]);

  const title = '404';

  return (
    <>
      <Helmet>
        <title>
          {$t({
            id: 'notFound.documentTitle',
            defaultMessage: 'Page not found - EBSCO Locate',
          })}
        </title>
      </Helmet>
      <PageErrorMessage
        title={title}
        titleTag="h1"
        subTitle={$t({
          id: 'notFound.pageNotFound',
          defaultMessage: 'Page not found',
        })}
        text={$t({
          id: 'notFound.requestedPageNotFound',
          defaultMessage:
            'The page you requested cannot be found. Try refreshing or return to the homepage.',
        })}
        buttonText={$t({
          id: 'notFound.backToHomepage',
          defaultMessage: 'Back to homepage',
        })}
        image={<Image src={NotFoundImage} alt={title} />}
        imagePlacement="block-end"
        className={cn('container', css.container)}
        onClick={navigateToSearchPage}
      />
    </>
  );
});

NotFoundPage.displayName = 'NotFoundPage';
